import { DefaultStateType } from './searchType'
import { trim } from '../../../../utils/tools'

export const defaultState: DefaultStateType = {
    value: []
}

// 初始取历史记录值
function getHistoryFromStorage() {
    let history
    const searchHistoryFromStoarge = []
    if (window.localStorage.getItem('HOMEPAGE/SEARCH/HISTORY') && window.localStorage.getItem('HOMEPAGE/SEARCH/HISTORY') !== null) {
        history = JSON.parse(window.localStorage.getItem('HOMEPAGE/SEARCH/HISTORY'))
    }

    if (history) {
        if (history.length > 1) {
            for (const [index, value] of Object.entries(history)) {
                searchHistoryFromStoarge.push(value)
            }
            return searchHistoryFromStoarge
        } else {
            searchHistoryFromStoarge.push(history[0])
            return searchHistoryFromStoarge
        }
    } else {
        return null
    }
}

function insertValueToStorage(value: string, ItemType: string, url: string = `${value}`) {
    const UserTypeValue = trim(value)
    let getHistoryArr = getHistoryFromStorage()

    if (getHistoryArr !== null) {
        for (const [index, item] of Object.entries(getHistoryArr)) {
            if (UserTypeValue === item.name) {
                const tempObj = {
                    name: UserTypeValue,
                    type: ItemType,
                    url
                }
                getHistoryArr.splice(Number(index), 1)
                getHistoryArr.unshift(tempObj)
                window.localStorage.setItem('HOMEPAGE/SEARCH/HISTORY', JSON.stringify(getHistoryArr))
                return getHistoryArr.length > 8 ? getHistoryArr.splice(0, 8) : getHistoryArr
            }
       }
    } else {
        getHistoryArr = []
    }

    const tempArr = []
    tempArr.push({
        name: UserTypeValue,
        type: ItemType,
        url
    })

    const insertArr = tempArr.concat(getHistoryArr)
    window.localStorage.setItem('HOMEPAGE/SEARCH/HISTORY', JSON.stringify(insertArr))
    return insertArr.length > 8 ? insertArr.splice(0, 8) : insertArr
}

function deleteHistoryFromStorage() {
    window.localStorage.setItem('HOMEPAGE/SEARCH/HISTORY', '')
}

export function reducer(state: DefaultStateType, action: any) {
    switch (action.type) {
        case 'GET_SEARCH_HISTORY':
            let history = getHistoryFromStorage()
            if (history && history.length > 8) {
                history = history.splice(0, 8)
            }
            return {...state, value: state.value = history}
        case 'DELETE_SEARCH_HISTORY':
            deleteHistoryFromStorage()
            return {...state, value: state.value = []}
        case 'SET_SEARCH_HISTORY':
            const insertRes = insertValueToStorage(action.payload.value, action.payload.ItemType, action.payload.url)
            return {...state, value: state.value = insertRes}
        case 'GET_SEARCH_CONFIG':
            const newInsertResult = action.payload
            return {...Object.assign(state, newInsertResult), value: state.value}
        default:
            throw new Error()
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/reducer.ts